import Apiservices from '../../lib/ApiServices'

// This route lives under /api (not /api/v1) on vendor-api, outside the panel's
// axios baseURL — called with an absolute URL to bypass it. No auth required
// server-side (public catalog lookup), so failures fail-safe to an empty list.
const VENDOR_API_ORIGIN = 'https://vendor.api.koninstore.com'

export type CountryPaymentGateway = {
  id: number
  country_id: number
  factory_name: string
  purpose: 'subscription' | 'service_fee' | 'customer_checkout'
  is_enabled: boolean
  sort_order: number
}

const PaymentGatewaysApi = {
  isFactoryEnabledForCountry: async (
    countryId: number | string | null | undefined,
    purpose: 'subscription' | 'service_fee' | 'customer_checkout',
    factoryName: string
  ): Promise<boolean> => {
    if (!countryId) {
      return false
    }

    try {
      const res = await Apiservices.get(
        `${VENDOR_API_ORIGIN}/api/countries/${countryId}/payment-gateways`,
        {params: {purpose}}
      )
      const gateways: CountryPaymentGateway[] = res?.data?.data?.gateways || []

      return gateways.some((gateway) => gateway.factory_name === factoryName && gateway.is_enabled)
    } catch (error) {
      return false
    }
  },
}

export default PaymentGatewaysApi
